import { createSlice } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { auth } = stateEnum

const initialState = {
  token: null,
  user: {},
  menu: [],
  userSetting: [],
  isAuthenticated: false,
  isInvalidToken: false,
  tokenExpiry: "",
  detailParam: {},
  isNewEntry: false,
}

const authSlice = createSlice({
  name: auth,
  initialState,
  reducers: {
    setLogin: (state, action) => {
      state.token = action.payload.token
      state.user = action.payload.user
      state.menu = action.payload.menu
      state.isAuthenticated = action.payload.isAuthenticated
      state.userSetting = action.payload.userSetting
    },
    setLogout: (state) => {
      state.token = null
      state.user = {}
      state.menu = []
      state.isAuthenticated = false
      state.tokenExpiry = ""
      //ssstate.isInvalidToken=true
    },
    setTokenExpiry: (state, action) => {
      state.tokenExpiry = action.payload
    },
    setInvalidToken: (state, action) => {
      state.isInvalidToken = action.payload
    },
    setDetailParam: (state, action) => {
      state.detailParam = action.payload
    },
    setNewEntryMode: (state, action) => {
      state.isNewEntry = action.payload
    },
    resetDetail: (state) => {
      state.detailParam = {}
      state.isNewEntry = true

    },
  },
})

export const { setLogout, setLogin, setTokenExpiry, setInvalidToken, setDetailParam, setNewEntryMode,resetDetail } = authSlice.actions

export default authSlice.reducer
